var _ellipse, _path, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDataCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30,
    cy: 29.9988,
    rx: 30,
    ry: 29.9988,
    fill: "#EFF6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2756 19.2059V19.2051C12.2756 17.7054 13.4668 16.507 14.9825 16.507H44.6553C46.1775 16.507 47.3808 17.7119 47.3808 19.2051V41.2951C47.3808 42.7884 46.1775 43.9932 44.6553 43.9932H14.9825C13.4604 43.9932 12.2572 42.7886 12.257 41.2955C12.257 41.2954 12.257 41.2953 12.257 41.2951L12.2756 19.2059Z",
    stroke: "#222222",
    strokeWidth: 1.96715
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.2715,
    y: 20.7246,
    width: 29.4545,
    height: 3.2726,
    fill: "#6484F1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.2715,
    y: 28.2148,
    width: 29.4545,
    height: 3.2726,
    fill: "#6484F1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataCard);
export default __webpack_public_path__ + "static/media/data-card.50aa11d7f5b3016bb1ff832ad330eeb6.svg";
export { ForwardRef as ReactComponent };